import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { 
  Container, 
  Grid, 
  Typography, 
  Box,
  CircularProgress,
} from '@mui/material';
import axios from 'axios';
import '../Course/CoursePreview.css';
import LearningPathHeader from './LearningPathHeader';
import LearningPathPrerequisites from './LearningPathPrerequisites';
import LearningPathDescription from './LearningPathDescription';
import LearningPathModules from './LearningPathModules';
import LearningPathDetails from './LearningPathDetails';
import { useUser } from '../../context/UserContext';
import PageTabs from '../shared/PageTabs';
import { buildLPathTabs } from '../shared/tabConfigs';
const LearningPathPreview = () => {
  const { id: lpathId, instanceId } = useParams();
  
  const [loading, setLoading] = useState(true);
  const [lpathData, setLpathData] = useState(null);
  const [error, setError] = useState(null);
  const { user } = useUser();
  const userRole = user?.role_id;

  const lpathTabs = buildLPathTabs(lpathId, { permissions: user?.permissions || [], roleId: user?.role_id });

  useEffect(() => {
    const fetchLPathData = async () => {
      try {
        setLoading(true);
        // Use the existing route but request JSON format
        const url = `/api/learner/lpath/${lpathId}${instanceId ? `/${instanceId}` : ''}?format=json`;
        const response = await axios.get(url);
        
        if (response.data.success) {
          setLpathData(response.data.data);
        } else {
          throw new Error(response.data.message || 'Failed to load learning path data');
        }
      } catch (err) {
        console.error('Error fetching learning path preview:', err);
        setError(err.message || 'An error occurred while loading the learning path');
      } finally {
        setLoading(false);
      }
    };

    fetchLPathData();
  }, [lpathId, instanceId]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error || !lpathData) {
    return (
      <Container>
        <Typography variant="h6" color="error" align="center">
          {error || 'Learning path not found'}
        </Typography>
      </Container>
    );
  }

  // Ensure all required data has default values
  const { 
    lpath = {}, 
    contents = [], 
    instance = {}, 
    instances = [], 
    contentStats = {
      total: 0,
      completed: 0,
      courses: 0,
      learningPaths: 0
    }, 
     
    prerequisites = {
      prerequisites: [],
      total: 0,
      completed: 0,
      required: 0
    },
  } = lpathData || {};
  return (
    <Box sx={{ width: '100%', py: 4, mt: -3 }}>
      {user?.role_id !== 2 && <PageTabs tabs={lpathTabs} />  }    
      <LearningPathHeader 
        lpath={lpath} 
        contentStats={contentStats} 
        enrollmentCount={lpathData.enrollmentCount || 0} 
        contents={contents}
        userRole={userRole}
        showEnrollCount={[1, 11, 5, 7].includes(userRole)}
      />
      <Container maxWidth="lg">
        <Grid container spacing={3}>        
          {/* Left column - 8/12 width */}
          <Grid item xs={12} md={8}>
            {prerequisites && prerequisites.prerequisites && prerequisites.prerequisites.length > 0 && (
              <LearningPathPrerequisites 
                prerequisites={prerequisites} 
                parentLPathId={lpathId}
                parentLPathName={lpath.title}
              />
            )}
            
            
            
            <LearningPathModules 
              contents={contents} 
              lpathId={lpathId} 
              contentStats={contentStats} 
              enrolled={true} // Always show as enrolled for admin preview
              lpath={lpath}
            />
          </Grid>
          
          {/* Right column - 4/12 width */}
          <Grid item xs={12} md={4}>
            
            <LearningPathDetails 
              lpath={lpath}
              instance={instance}
              instances={instances}
              contentStats={contentStats}
              contents={contents}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default LearningPathPreview;